import jwtDecode from 'jwt-decode';

/**
 * Extract user roles from JWT access token
 * @param {string} accessToken - The JWT access token
 * @returns {Array<string>} Array of role names
 */
export const getUserRolesFromToken = (accessToken) => {
  if (!accessToken) return [];

  try {
    const decoded = jwtDecode(accessToken);
    // Get roles from the user_roles claim
    return decoded.user_roles || [];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error decoding token:', error);
    return [];
  }
};

/**
 * Check if user has a specific role
 * @param {string} accessToken - The JWT access token
 * @param {string} roleName - The role to check for
 * @returns {boolean}
 */
export const hasRole = (accessToken, roleName) => {
  const roles = getUserRolesFromToken(accessToken);
  return roles.includes(roleName);
};

/**
 * Check if user has admin role
 * @param {string} accessToken - The JWT access token
 * @returns {boolean}
 */
export const hasAdminRole = (accessToken) => hasRole(accessToken, 'Admin');

/**
 * Check if user has data engineer role
 * @param {string} accessToken - The JWT access token
 * @returns {boolean}
 */
export const hasDataEngineerRole = (accessToken) => hasRole(accessToken, 'Data Engineer');

/**
 * Check if user has analyst role
 * @param {string} accessToken - The JWT access token
 * @returns {boolean}
 */
export const hasAnalystRole = (accessToken) => hasRole(accessToken, 'Analyst');

/**
 * Check if user has any of the specified roles
 * @param {string} accessToken - The JWT access token
 * @param {Array<string>} roleNames - Array of role names to check
 * @returns {boolean}
 */
export const hasAnyRole = (accessToken, roleNames) => {
  const userRoles = getUserRolesFromToken(accessToken);
  return roleNames.some((role) => userRoles.includes(role));
};
